module.exports = __webpack_public_path__ + "media/country_flags/cm-e1564aa2.png";